import React, { useState } from "react";
import "../index.css";

const AddVehicle = () => {
  const [vehicleData, setVehicleData] = useState({
    type: "",
    brand: "",
    model: "",
    mileage: "",
    rent: "",
    image: null,
  });

  const handleChange = (e) => {
    setVehicleData({ ...vehicleData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    setVehicleData({ ...vehicleData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { type, brand, model, mileage, rent, image } = vehicleData;

    if (!type || !brand || !model || !mileage || !rent || !image) {
      alert("All fields are required!");
      return;
    }

    const formData = new FormData();
    Object.entries(vehicleData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND}/api/vehicles`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        alert("Vehicle uploaded successfully!");
        setVehicleData({ type: "", brand: "", model: "", mileage: "", rent: "", image: null });
      } else {
        alert("Error: " + (data.error || "Unknown error"));
      }
    } catch (error) {
      alert("Error uploading vehicle");
    }
  };

  return (
    <div className="add-vehicle-container container mt-4">
      <h2 className="add-vehicle-title text-center mb-4">Upload Vehicle</h2>
      <form className="add-vehicle-form" onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label>Vehicle Type:</label>
          <select name="type" className="form-control" onChange={handleChange} value={vehicleData.type} required>
            <option value="" disabled>Select Vehicle Type</option>
            <option value="SUV">SUV</option>
            <option value="Sedan">Sedan</option>
            <option value="Hatchback">Hatchback</option>
            <option value="Convertible">Convertible</option>
            <option value="Pickup Truck">Pickup Truck</option>
            <option value="Minivan">Minivan</option>
            <option value="Coupe">Coupe</option>
            <option value="Sports Car">Sports Car</option>
          </select>
        </div>

        <div className="form-group mb-3">
          <label>Brand:</label>
          <input type="text" name="brand" className="form-control" onChange={handleChange} value={vehicleData.brand} required />
        </div>

        <div className="form-group mb-3">
          <label>Car Model:</label>
          <input type="text" name="model" className="form-control" onChange={handleChange} value={vehicleData.model} required />
        </div>

        <div className="form-group mb-3">
          <label>Mileage:</label>
          <input type="text" name="mileage" className="form-control" onChange={handleChange} value={vehicleData.mileage} required />
        </div>

        <div className="form-group mb-3">
          <label>Rent Price:</label>
          <input type="text" name="rent" className="form-control" onChange={handleChange} value={vehicleData.rent} required />
        </div>

        <div className="form-group mb-3">
          <label>Upload Car Image:</label>
          <input type="file" name="image" className="form-control" onChange={handleImageUpload} required />
        </div>

        <button type="submit" className="btn btn-primary w-100 mt-3">
          Upload Vehicle
        </button>
      </form>
    </div>
  );
};

export default AddVehicle;
